import {SWITCH_LANGUAGE} from '../constants/i18nConstants';
import {createReducer} from '../utils/reducerHelper';
import enMessages from '../locale/en';

const localeMessages = {
  en: enMessages,
};

//Default is english
const initialState = {
  locale: 'en',
  messages: enMessages,
  key: 'en'
};

export default createReducer(initialState, {
  [SWITCH_LANGUAGE]: (state, payload) => {
    return Object.assign({}, state, {
      locale: payload.lang,
      messages: localeMessages[payload.lang],
      key: payload.lang
    });
  }
});



// WEBPACK FOOTER //
// ./src/reducers/i18nReducer.js